// extracted by css-extract-rspack-plugin
export default {"content":"content-eiiZkU","headerTitle":"headerTitle-wcJbrl","statusIcon":"statusIcon-dCjvJl","orangeButton":"orangeButton-fUTWPt","body":"body-cltVzF"};